const headerLinks = [
  { name: "Home", href: "/" },
  { name: "About", href: "/" },
  { name: "Contact", href: "/" },
  { name: "Blog", href: "/" },
  { name: "Careers", href: "/" },
];

export default headerLinks;
